import { IoMdClose } from "react-icons/io";
import styles from "./AiModal.module.css";

export default function AiModal({
  isOpen,
  onClose,
  titleContent,
  children,
  footerContent,
}) {
  if (!isOpen) return null;

  return (
    <div className={styles.ai_modal_overlay} onClick={onClose}>
      <div
        className={styles.ai_modal_content}
        onClick={(e) => e.stopPropagation()}
      >
        {/* title */}
        <div className={`${styles.ai_modal_title_bar}`}>
          <div>{titleContent}</div>
          <button className={`${styles.ai_modal_close_btn}`} onClick={onClose}>
            <IoMdClose />
          </button>
        </div>

        {/* content */}
        <div className={styles.ai_content}>{children}</div>

        {/* footer */}
        <div className={styles.ai_footer}>{footerContent}</div>
      </div>
    </div>
  );
}
